export default {
  DEFAULT_VALUE: 'defaultValue',
  DEPENDENT_FIELD_FILTERS: 'dependentFieldFilters',
  DESCRIPTION: 'description',
  DISPLAY_ORDER: 'displayOrder',
  ENABLED: 'enabled',
  FIELD_TYPE: 'fieldType',
  GROUP_NAME: 'groupName',
  HIDDEN: 'hidden',
  IS_SELECTED: 'isSelected',
  IS_SMART_FIELD: 'isSmartField',
  LABEL_HIDDEN: 'labelHidden',
  LABEL: 'label',
  META_DATA: 'metaData',
  NAME: 'name',
  OBJECT_TYPE_ID: 'objectTypeId',
  OPTIONS: 'options',
  PLACEHOLDER: 'placeholder',
  PROPERTY_OBJECT_TYPE: 'propertyObjectType',
  REQUIRED: 'required',
  SELECTED_OPTIONS: 'selectedOptions',
  TYPE: 'type',
  UNSELECTED_LABEL: 'unselectedLabel',
  VALIDATION: 'validation'
};